import { createContext, FC, ReactNode, useContext } from 'react';
import { Dictionaries } from 'src/pages/app/_BLL/metaDictionaries/types';
import { UserData } from 'src/pages/SignInPage/_BLL/types';

interface Context {
	userData: UserData;
	dictionaries: Dictionaries;
}

interface Props extends Context {
	children: ReactNode;
}

const CoreDataContext = createContext<Context | null>(null);

const CoreDataContextProvider: FC<Props> = (props) => {
	const {
		userData, //
		dictionaries,
		children,
	} = props;

	// * Render
	return (
		<CoreDataContext.Provider
			value={{
				userData,
				dictionaries,
			}}
		>
			{children}
		</CoreDataContext.Provider>
	);
};

const useCoreDataContext = () => {
	const context = useContext(CoreDataContext);

	if (!context) {
		throw new Error('useCoreDataContext must be used within MetaContextProvider');
	}

	return context;
};

export { CoreDataContextProvider, useCoreDataContext };
